export const CUSTOM_TYPE_PROFILE_SEARCH = "profilesearch";

export const NewProfileSearchQuestionProperties = {
  panelTag: "panelTag",
  directoryId: "directoryId",
  newProfileWorkflowId: "newProfileWorkflowId",
  emailRequired: "emailRequired",
  affiliationRequired: "affiliationRequired",
  firstNameRequired: "firstNameRequired",
  lastNameRequired: "lastNameRequired",
  overrideAffiliation: "overrideAffiliation",
  allowRemovePanel: "allowRemovePanel",
  titleLocation: "titleLocation",
  preventMultipleAssignment: "preventMultipleAssignment",
  allowInlineParticipantEntry: "allowInlineParticipantEntry",
};

export const ProfileSearchMultipleQuestionType = "profilesearchmultiple";

export const ProfileSearchMultipleQuestionProperties = {
  profileSearchQuestionProperties: NewProfileSearchQuestionProperties,
  roleItemValueProperties: {
    value: "value",
    text: "text",
    min: "min",
    max: "max",
    trackPositions: "trackPositions",
    allowChangePosition: "allowChangePosition",
    allowChangeProfile: "allowChangeProfile",
  },
  autoAssignSubmitter: "autoAssignSubmitter",
  role: "role",
  roleTitle: "roleTitle",
  profileSearchTitle: "profileSearchTitle",
  coauthorBlock: "coauthorBlock",
  styleSubmitter: "styleSubmitter",
  submitterClassName: "submitterClassName",
  blockContainerClassName: "blockContainerClassName",
};
